import React from "react";
import { useParams, Link } from "react-router-dom";
import team1 from "../../../assets/Makara.png";
import team2 from "../../../assets/Maranin.png";
import team3 from "../../../assets/Apeksha.png";

const TeamMemberProfile = () => {
  const { slug } = useParams();

  const teamMembers = [
    {
      slug: "makara-heng",
      name: "Makara Heng",
      role: "Head Of Business",
      phone: "+855 78 333 593",
      email: "makaraheng@ceylonambassador.com",
      img: team1,
      bio: [
        "Brings over 10 years of experience in airfreight shipping, logistics, and supply chain management. Professional background includes customer service and documentation at United Arab Shipping Company, sales and corporate VIP account management with Mediterranean Shipping Company (MSC), and end-to-end logistics operations management at Neak Express Transportation."
      ],
      specialty:
        "Head of Business at Ceylon Ambassador Co., Ltd., overseeing commercial strategy and market development in Cambodia.",
      degree:
        "Bachelor's Degree in Business Communication from Pannasastra University of Cambodia.",
      training: [
        "Professionally trained in Customer Service & Documentation Systems",
        "DG Orientation, Aviation Security Awareness, Airside Safety, and Cargo",
        "Safety Management System (SMS)."
      ]
    },
    {
      slug: "maranin-soeung",
      name: "Maranin Soeung",
      role: "Business Development Manager",
      phone: "+855 15 398 699",
      email: "sales1kh@ceylonambassador.com",
      img: team2,
      bio: [
        "Based in Phnom Penh, Cambodia, with experience in freight forwarding, combining industry expertise and a strong academic background to deliver efficient and reliable freight solutions."
      ],
      specialty:
        "6+ years of experience in freight forwarding, formerly Airfreight Manager at Bollore Logistics Cambodia.",
      degree: "BB in Business Administration and Management.",
      training: [
        "TOEFL (ESL) - American International Institute",
        "Sinology - Toun Ea Chinese School",
        "Tangram Climate Program 2024 - Imperial College Business School"
      ]
    },
    {
      slug: "apeksha-somarathne",
      name: "Apeksha Somarathne",
      role: "Head of Finance",
      phone: "+94 77 363 0365",
      email: "finance@ufs.group",
      img: team3,
      bio: [
        "Group Accountant with regional responsibility across Sri Lanka, Cambodia, and Dubai. Strong experience in multi-currency accounting, financial reporting, and cross-border coordination. Skilled in ERP systems, reporting, and financial decision support."
      ],
      specialty:
        "14 years in freight forwarding – previous roles include Assistant Finance Manager / Assistant Accountant at Freight Line International (Pvt) Ltd & Marine Logistics Services.",
      degree:
        "Chartered Institute of Sri Lanka & NIBM (National Institute of Business Management).",
      training: [
        "ICASL partly qualified with Advanced Diploma in Finance & Management."
      ]
    }
  ];

  const member = teamMembers.find((m) => m.slug === slug);

  if (!member) {
    return (
      <div className="text-center py-20 text-xl font-semibold">
        Team member not found
      </div>
    );
  }

  return (
    <div className="container max-w-screen-lg mx-auto px-4 py-6">
      {/* Breadcrumb */}
      <div className="text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:underline">Home</Link> /{" "}
        <Link to="/team" className="hover:underline">Team</Link> /{" "}
        <span className="font-bold text-gray-900">{member.name}</span>
      </div>

      <div className="mt-24 flex flex-col lg:flex-row gap-20">
        {/* Left Column */}
        <div className="lg:w-1/4">
          <img
            src={member.img}
            alt={member.name}
            className="rounded-full w-36 h-36 object-cover mb-6"
          />
          <p className="text-gray-500">{member.role}</p>
          <h1 className="text-2xl font-bold mb-10">{member.name}</h1>

          <div className="border-t-2 border-b-2 py-6">{member.phone}</div>
          <div className="border-b-2 py-6">{member.email}</div>
        </div>

        {/* Right Column */}
        <div className="lg:w-3/4 font-Montserrat">
          {/* Bio */}
          <p className="mb-20 text-gray-700 leading-relaxed">
            {member.bio.join(" ")}
          </p>

          <hr className="my-6" />

          {/* Details Section */}
          <div className="text-sm text-gray-700">

            {/* Specialty */}
            <div className="border-b-2 py-6">
              <div className="grid grid-cols-[160px_1fr] gap-6">
                <strong>Specialty</strong>
                <span>{member.specialty}</span>
              </div>
            </div>

            {/* Degree */}
            <div className="border-b-2 py-6">
              <div className="grid grid-cols-[160px_1fr] gap-6">
                <strong>Degree</strong>
                <span>{member.degree}</span>
              </div>
            </div>

            {/* Training */}
            <div className="border-b-2 py-6 mb-40">
              <div className="grid grid-cols-[160px_1fr] gap-6">
                <strong>Training</strong>
                <div className="flex flex-col gap-1">
                  {member.training.map((item, idx) => (
                    <p key={idx}>{item}</p>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamMemberProfile;
